import { useState } from 'react';
import ReactPlayer from 'react-player'
import playButton from './media/play-button.png';
import sizeRef from './media/video-size-ref.png';
import './scss/VideoPlayer.scss';

function VideoPlayer({ videos }) {

  const [isPlaying, setIsPlaying] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(0)

  function play() {
    setIsPlaying(true)
  }

  function pause() {
    setIsPlaying(false)
  }

  function prev() {
    if (currentVideo > 0) {
      setCurrentVideo(currentVideo - 1)
    }
  }

  function next() {
    if (currentVideo < videos.length -1) {
      setCurrentVideo(currentVideo + 1)
    }
  }

  return (
    <div className="video-player-container">
      <img className="size-ref" src={sizeRef} />
      <div className="video-player">
        <div className="progress-screen">
          {videos.map((video, index) => 
            <div 
              data-index={index} 
              className={index === currentVideo ? 'active' : 'inactive'}
              style={{width: `calc(100% / ${videos.length})` }}
              key={index}>
            </div>
          )}
        </div>

        {!isPlaying ? 
          <div className="play-screen" onClick={play}>
            <img src={playButton} />
          </div>
        : 
          <div className="prev-pause-next-screen">
            <div className="prev-button" onClick={prev}></div>
            <div className="pause-button" onClick={pause}></div>
            <div className="next-button" onClick={next}></div>
          </div>
        }

        <ReactPlayer 
          url={videos[currentVideo]} 
          playing={isPlaying}
          width='100%'
          height='auto'
          playsinline={true}
        />
      </div>
    </div>
  );
}

export default VideoPlayer;
